import { FURNITURE_CONFIG } from '~/components/ThreeDModel/furnitureConfig'
import { HANDLE_CONSTANTS } from '~/components/ThreeDModel/handleUtils'

export interface ComputeDoorDimensionsInput {
  columnWidth: number
  doorHeight: number
  isSplit: boolean
  isNewCollection: boolean
  isSingleNarrow: boolean
}

interface DoorPanel {
  width: number
  height: number
}

export interface DoorDimensionsResult {
  /** Sheet dimensions for each door panel (1 for single, 2 for split) */
  panels: DoorPanel[]
  /** Handle panel sheet dimensions (null when not NewCollection) */
  handlePanel: DoorPanel | null
  /** For 3D: right door envelope width (includes handle space). Equals sheet width when no handle. */
  rightDoorEnvelopeWidth: number
}

// TODO: Fix trigger on animation? Happens because of isColumnOpen depenedency
export function computeDoorDimensions(
  input: ComputeDoorDimensionsInput
): DoorDimensionsResult {
  const { columnWidth, doorHeight, isSplit, isNewCollection, isSingleNarrow } =
    input
  const { panelSpacing, panelThickness } = FURNITURE_CONFIG
  const { FULL_HEIGHT_HANDLE_WIDTH, FULL_HEIGHT_HANDLE_DEPTH } =
    HANDLE_CONSTANTS

  const handlePanel: DoorPanel | null = isNewCollection
    ? { width: FULL_HEIGHT_HANDLE_DEPTH, height: doorHeight }
    : null

  if (isSplit) {
    const totalDoorsWidth = columnWidth - panelSpacing
    const sheetWidth = isNewCollection
      ? (totalDoorsWidth - FULL_HEIGHT_HANDLE_WIDTH) / 2
      : totalDoorsWidth / 2

    const rightEnvelope = isNewCollection
      ? sheetWidth + FULL_HEIGHT_HANDLE_WIDTH
      : sheetWidth

    return {
      panels: [
        { width: sheetWidth, height: doorHeight },
        { width: sheetWidth, height: doorHeight },
      ],
      handlePanel,
      rightDoorEnvelopeWidth: rightEnvelope,
    }
  }

  const doorWidth = isSingleNarrow
    ? columnWidth + panelThickness
    : columnWidth - panelSpacing

  const sheetWidth = isNewCollection
    ? doorWidth - FULL_HEIGHT_HANDLE_WIDTH
    : doorWidth

  return {
    panels: [{ width: sheetWidth, height: doorHeight }],
    handlePanel,
    rightDoorEnvelopeWidth: doorWidth,
  }
}
